import { loadScript } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { isLayoutSectionAsset } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

function getScriptPriority(node) {
  const { src, type, defer, async } = node.attribs;

  if (!src) {
    return 1;
  }

  if (async !== undefined) {
    return 10;
  }

  return defer !== undefined || type === 'module' ? 1 : 0;
}

/**
 * @param {AssetLoader} assetLoader
 */
function processScripts(assetLoader) {
  return {
    shouldProcessNode(node) {
      return node.name === 'script' && !isLayoutSectionAsset(node);
    },
    processNode(node) {
      const loader = loadScript({
        src: node.attribs.src || null,
        content: node.children.length > 0 ? node.children[0].data : null,
        type: node.attribs.type || null,
        defer: node.attribs.defer || null,
        async: node.attribs.async || null,
      });

      if (loader) {
        assetLoader.addLayoutAsset(loader, getScriptPriority(node));
      }

      return null;
    },
  };
}

export default processScripts;
